const CreditPlanStatus = {
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVE",
  UPCOMING: "UPCOMING",
  EXPIRED: "EXPIRED"
};

export default CreditPlanStatus;
